<!--用于下拉列表, 支持editor-->
<template>
  <div v-if="editor" class="fi-dd-editor-add">
    <ElButton type="primary" link @click="createItem">{{
      editor.createText || '添加'
    }}</ElButton>
  </div>
  <slot />

  <ElOption
    v-for="item in (options as any)"
    :key="item.id"
    :class="{ 'fi-dd-option': !!editor }"
    :label="item.label"
    :value="item.id"
    :disabled="item.disabled"
  >
    <span>{{ item.label }}</span>

    <div
      v-if="editor && (editor.edit || editor.delete) && !item.hidden"
      class="icons"
    >
      <el-icon v-if="editor.edit" title="修改" @click.stop="editItem(item)">
        <Edit />
      </el-icon>
      <el-icon v-if="editor.delete" title="删除" @click.stop="deleteItem(item)">
        <Delete />
      </el-icon>
    </div>
  </ElOption>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { IdLabel, IdLabelList } from '../core/types';
import { DropdownEditor } from './DropdownEditor';
import { Edit, Delete } from '@element-plus/icons-vue';

const props = defineProps<{
  optionsData: IdLabelList;
  editor?: DropdownEditor; // 下拉列表编辑器
  beforeEdit?: () => void; // 关闭dropdown回调
  reload?: () => void; // 重新加载列表
}>();

const options = computed(() => {
  if (!props.editor) {
    return props.optionsData;
  }

  if (props.optionsData && props.optionsData.length > 0) {
    return props.optionsData;
  }

  // 返回一条空记录, 否则按钮不显示
  return [
    {
      id: 0,
      label: ' ',
      disabled: true,
      hidden: true
    }
  ];
});

async function createItem() {
  props.beforeEdit?.();
  await props.editor?.create?.();
  props.reload?.();
}

async function editItem(item: IdLabel) {
  props.beforeEdit?.();
  await props.editor?.edit?.(item);
  props.reload?.();
}

async function deleteItem(item: IdLabel) {
  props.beforeEdit?.();
  await props.editor?.delete?.(item);
  props.reload?.();
}
</script>

<style lang="scss" scoped>
// editor
.fi-dd-editor-add {
  margin: 0 16px;
  padding: 0 16px 0 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 40px;
  line-height: 40px;
  position: relative;
  top: -4px;

  :deep(.el-button) {
    width: 100%;
  }
}

.fi-dd-option {
  padding-right: 40px;

  &.is-disabled:last-child {
    cursor: default;
  }
}

.icons {
  visibility: hidden;
  display: inline-flex;
  align-items: center;
  column-gap: 4px;
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);

  :deep(.el-icon:hover) {
    background-color: rgb(226, 245, 226);
  }
}

.fi-dd-option:hover > .icons {
  visibility: visible;
}

.el-select-dropdown.is-multiple .fi-dd-option.selected:hover > .icons {
  visibility: hidden;
}
</style>
